var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bread_crumbs-1"},[_c('Link01'),_c('div',{staticClass:"text-2 avenirnextltpro-demi-normal-big-stone-10px"},[_vm._v("/")]),_c('ActualSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }